import { useEffect, useState } from "react";
import { useLocation, useRoute } from "wouter";
import { DetailLoading, DetailNotFound } from "../components/DetailStates";
import { apiAssetUrl } from "../lib/api";

async function publicLegacyPersonOwner(personId: string): Promise<number | null> {
  const url = apiAssetUrl(`/api/profile/legacy-person/${encodeURIComponent(personId)}/owner`);
  if (!url) return null;

  const response = await fetch(url, { credentials: "include" });
  if (!response.ok) return null;

  const payload: unknown = await response.json().catch(() => null);
  if (typeof payload !== "object" || payload === null || !("ownerUserId" in payload)) return null;
  const ownerUserId = payload.ownerUserId;
  return typeof ownerUserId === "number" && Number.isSafeInteger(ownerUserId) && ownerUserId > 0
    ? ownerUserId
    : null;
}

/** Resolves an old résumé link to its owner's unified member profile. */
export default function ResumeDetail() {
  const [, params] = useRoute("/p/:id");
  const [, navigate] = useLocation();
  const personId = params?.id || "";
  const [notFoundFor, setNotFoundFor] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    setNotFoundFor(null);

    publicLegacyPersonOwner(personId)
      .then((ownerUserId) => {
        if (!alive) return;
        if (ownerUserId === null) {
          setNotFoundFor(personId);
          return;
        }
        navigate(`/u/${ownerUserId}`, { replace: true });
      })
      .catch(() => {
        if (alive) setNotFoundFor(personId);
      });

    return () => { alive = false; };
  }, [navigate, personId]);

  if (notFoundFor === personId) {
    return <DetailNotFound title="Profile not found" backHref="/marketplace?tab=Jobseekers" backLabel="Browse Jobseekers" />;
  }

  return <DetailLoading label="Opening member profile…" />;
}
